import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

function PrivateSidebar({
  children,
  name,
  onCloseMenu,
}: PropsWithChildren<{ name: string; onCloseMenu(): void }>) {
  const { t } = useTranslation();

  return (
    <div className="layout_sidebar">
      <div className="sidebar_head">
        <button className="close-sidebar-btn" onClick={onCloseMenu}></button>

        <p className="welcome">{t("common:sidebar.WELCOME")}</p>
        <p className="user-name">{name}</p>
        <hr />
      </div>

      {children}
    </div>
  );
}

export default PrivateSidebar;
